import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { IStoreinfoUnitsList, IDropDownList, IStoreinfoUnitsDetails, ISaveDeleteResponse, IisExist, IImportFacilityUnits, ISaveModel, IUnitLevelDepositImportModel, IUnitLevelRentChargesImportModel, IUnitLevelDiscountImportModel, IUnitLevelTaxImportModel, IUnitLevelFeesImportModel, IUnitLevelLateandLienImportModel, IUnitLevelAttributeImportModel, IStorinfoUnitypesDetails, IUnitTypeFeesImportModel, IUnitTypeTaxImportModel, IUnitTypeDiscountImportModel, IUnitTypeAttributeImportModel, IUnitTypeLateandLienImportModel, IUnitTypeDepositImportModel, IUnitTypeRentChargesImportModel, IUnitLockDetails, IUnitDetails, IApiResponse, IUnitLocksImportModel, ILienDetails, IUnitLayoutStatusModel, IPersonaIntegrationModel, IAuctionCategories, IAuctionDetails, IBulkAttributeSaveRequest } from '../Shared/interface';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { AppInsightsService } from './app-insights.service';
import { catchError, map } from 'rxjs/operators';
import {AppService} from './app.service';

@Injectable({
    providedIn: 'root'
})

export class StoreinfoUnitService {
    private baseURL =  this.appService.config.apiBaseUrl;
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) {

    }
    getFacilityUnitsListInfScroll(model): Observable<IStoreinfoUnitsList[]> {
            const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
            let url = `${this.baseURL}/Store/GetFacilityUnitList`;
            return this.http.post<IStoreinfoUnitsList[]>(url, model, options)
            .pipe(
                map(res  => {
                return res as IStoreinfoUnitsList[];
        }),
        catchError(this.handleError)
            );
    }

    getFacilityUnitsList(facId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Store/GetFacilityUnits?facilityId=${facId}`)
            .pipe(
                map(res  => {
                return res as any;
        }),
        catchError(this.handleError)
            );
    }

    getFacilityUnitsListForOp(facId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Store/GetFacilityUnitsForOp?facilityId=${facId}`)
            .pipe(
                map(res  => {
                return res as any;
        }),
        catchError(this.handleError)
            );
    }

    getDropdownAllList(facId): Observable<IDropDownList> {
        return this.http.get<IDropDownList>(
            `${this.baseURL}/Store/GetUnitDropDownList?facilityId=${facId}`)
            .pipe(
                map(res  => {
                return res as IDropDownList;
        }),
        catchError(this.handleError)
            );
    }
    
    getFacilityUnitsDetails(facId,UnitId): Observable<IStoreinfoUnitsDetails> {
        return this.http.get<IStoreinfoUnitsDetails>(
            `${this.baseURL}/Store/GetFacilityUnitDetails?facilityId=${facId}&unitid=${UnitId}`)
            .pipe(
                map(res  => {
                return res as IStoreinfoUnitsDetails;
        }),
        catchError(this.handleError)
            );
    }

    GetUnitLockDetailsFromDaVinci(facId, unitNo): Observable<IUnitLockDetails[]> {
        return this.http.get<IUnitLockDetails[]>(
            `${this.baseURL}/Store/GetUnitLockDetailsFromDaVinci?facilityId=${facId}&unitNo=${unitNo}`)
            .pipe(
                map(res =>{
                    return res as IUnitLockDetails[];
                }),
                catchError(this.handleError)
            );
    }
    SyncAllUnitLockDetails(facId:number): Observable<IApiResponse> {
        const options = {headers: new HttpHeaders({'Content-Type':'application/json'})};
        return this.http.post<IApiResponse>(
            `${this.baseURL}/Store/SyncAllUnitLockDetails?facilityId=${facId}`,options)
            .pipe(
                map(res =>{
                    return res as IApiResponse;
                }),
                catchError(this.handleError)
            );
    }
    
    getUnitLockLienDetails(unitNo, facId): Observable<ILienDetails[]> {
        return this.http.get<ILienDetails[]>(
            `${this.baseURL}/Store/GetUnitLockLienDetails?unitNo=${unitNo}&facilityId=${facId}`)
            .pipe(
                map(res =>{
                    return res as ILienDetails[];
                }),
                catchError(this.handleError)
            );
    }

    updateUnitLockDetails(unitId,facilityId,lockDetails): Observable<ISaveDeleteResponse> {
        const options = {headers: new HttpHeaders({'Content-Type':'application/json'})};
        let url = `${this.baseURL}/Store/UpdateUnitLockDetails?unitId=${unitId}&facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url,lockDetails,options)
        .pipe(
            map(res =>{
                return res as ISaveDeleteResponse;
            }),
            catchError(this.handleError)
        );
    }

    getFacilityUnitsExport(facId,storeCode, exportType): Observable<ISaveModel> {
        return this.http.get<ISaveModel>(
            `${this.baseURL}/Store/ExportFacilityUnit?facilityId=${facId}&storeCode=${storeCode}&exportType=${exportType}`)
            .pipe(
                map(res  => {
                return res as ISaveModel;
        }),
        catchError(this.handleError)
            );
    }

    getFacilityUnitTypesExport(facId,storeCode, exportType): Observable<ISaveModel> {
        return this.http.get<ISaveModel>(
            `${this.baseURL}/Store/ExportFacilityUnitTypes?facilityId=${facId}&storeCode=${storeCode}&exportType=${exportType}`)
            .pipe(
                map(res  => {
                return res as ISaveModel;
        }),
        catchError(this.handleError)
            );
    }

    saveFacilityUnit(facUnit: IStoreinfoUnitsDetails): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if(facUnit.UnitId === 0) {
            url = `${this.baseURL}/Store/CreateFacilityUnits`;
        } else {
            url = `${this.baseURL}/Store/UpdateFacilityUnits`;
        }

        return this.http.post<ISaveDeleteResponse>(url, facUnit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
      ImportFacilityUnits(facUnit: IStoreinfoUnitsDetails[]): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';

            url = `${this.baseURL}/Store/ImportFacilityUnits`;


        return this.http.post<ISaveDeleteResponse>(url, facUnit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
      ImportFacilityUnitBaseRent(UnitBaseRent: IUnitLevelDepositImportModel[], facilityId): Observable<ISaveDeleteResponse> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      let url = '';

          url = `${this.baseURL}/Store/ImportFacilityUnitBaseRent?facilityId=${facilityId}`;


      return this.http.post<ISaveDeleteResponse>(url, UnitBaseRent, options)
          .pipe(
              map(res => {
                  return res;
              }),
              catchError(this.handleError)
          );
    }
    ImportFacilityUnitRent(UnitRentCharges: IUnitLevelRentChargesImportModel[], facilityId): Observable<ISaveDeleteResponse> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      let url = '';

          url = `${this.baseURL}/Store/ImportFacilityUnitRent?facilityId=${facilityId}`;


      return this.http.post<ISaveDeleteResponse>(url, UnitRentCharges, options)
          .pipe(
              map(res => {
                  return res;
              }),
              catchError(this.handleError)
          );
    }
    ImportFacilityUnitLocks(unitLockDetails: IUnitLocksImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers : new HttpHeaders({'Content-Type':'application/json'})};
        let url =`${this.baseURL}/Store/ImportFacilityUnitLocks?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url,unitLockDetails,options)
        .pipe(
            map(res=>{
                return res;
            }),
            catchError(this.handleError)
        )
    }
    ImportFacilityUnitDiscount(impDiscount: IUnitLevelDiscountImportModel[], facilityId): Observable<ISaveDeleteResponse> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      let url = '';
      url = `${this.baseURL}/Store/ImportFacilityUnitDiscount?facilityId=${facilityId}`;
     return this.http.post<ISaveDeleteResponse>(url, impDiscount, options)
          .pipe(
              map(res => {
                  return res;
              }),
              catchError(this.handleError)
          );
    }
    ImportFacilityUnitTax(impTax: IUnitLevelTaxImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTax?facilityId=${facilityId}`;
       return this.http.post<ISaveDeleteResponse>(url, impTax, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
      ImportFacilityUnitFees(impFees: IUnitLevelFeesImportModel[]): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitFees`;
       return this.http.post<ISaveDeleteResponse>(url, impFees, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
      ImportFacilityUnitLateandLien(impLateAndLien: IUnitLevelLateandLienImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitLateandLien?facilityId=${facilityId}`;
       return this.http.post<ISaveDeleteResponse>(url, impLateAndLien, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
      ImportFacilityUnitAttribute(impAttr: IUnitLevelAttributeImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitAttribute?facilityId=${facilityId}`;
       return this.http.post<ISaveDeleteResponse>(url, impAttr, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }
     
    deleteUnitList(remUnits) {
        let url ='';
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        url = `${this.baseURL}/Store/DeleteFacilityUnits`;
        return this.http.post<ISaveDeleteResponse[]>( url, remUnits, options).pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );;
    }
    getIsUnitNoExists(UnitNo,facId): Observable<IisExist> {
        return this.http.get<IisExist>(
            `${this.baseURL}/Store/UnitNoExists?unitNo=${UnitNo}&facilityId=${facId}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const isExist = result.body as IisExist;
                        return isExist;
                }
                ),
                catchError(this.handleError)
            );
    }
    getFacilityUnitsImport(units): Observable<IImportFacilityUnits[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/Store/ImportFacilityUnits`;
        return this.http.post<IImportFacilityUnits[]>(url, units, options)
        .pipe(
            map(res  => {
            return res as IImportFacilityUnits[];
    }),
    catchError(this.handleError)
        );
}

// UnitType services

    ImportFacilityUnitTypes(facUnit: IStorinfoUnitypesDetails[], facId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypes?facilityId=${facId}`;
        return this.http.post<ISaveDeleteResponse>(url, facUnit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypesFees(impFees: IUnitTypeFeesImportModel[], facId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesFees?facilityId=${facId}`;
        return this.http.post<ISaveDeleteResponse>(url, impFees, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypesTax(impTax: IUnitTypeTaxImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesTax?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, impTax, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypeDiscount(impDiscount: IUnitTypeDiscountImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesDiscount?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, impDiscount, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypeAttribute(impAttr: IUnitTypeAttributeImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesAttribute?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, impAttr, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypeLateandLien(impLateAndLien: IUnitTypeLateandLienImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesLateAndLien?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, impLateAndLien, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypeBaseRent(UnitBaseRent: IUnitTypeDepositImportModel[], facilityId): Observable<ISaveDeleteResponse> {

        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesBaseRent?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, UnitBaseRent, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    ImportFacilityUnitTypeRent(UnitRentCharges: IUnitTypeRentChargesImportModel[], facilityId): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/ImportFacilityUnitTypesRent?facilityId=${facilityId}`;
        return this.http.post<ISaveDeleteResponse>(url, UnitRentCharges, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    IsLicenseAndDavinciExist(facilityId): Observable<Boolean>{
        return this.http.get<boolean>(
          `${this.baseURL}/Store/IsLicenseAndDavinciExist?facilityId=${facilityId}`)
            .pipe(
                map(res => {
                    return res as boolean;
                }),
                catchError(this.handleError)
            );
    }

    IsLicenseAndDavinciExistForOp(facilityId): Observable<Boolean>{
        return this.http.get<boolean>(
          `${this.baseURL}/Store/IsLicenseAndDavinciExistForOp?facilityId=${facilityId}`)
            .pipe(
                map(res => {
                    return res as boolean;
                }),
                catchError(this.handleError)
            );
    }

    IsLicenseAndPersonaExistsForOp(facilityId: number, tenantId: number): Observable<IPersonaIntegrationModel> {
        return this.http.get<IPersonaIntegrationModel>(
            `${this.baseURL}/Store/IsLicenseAndPersonaExistForOp?facilityId=${facilityId}&tenantId=${tenantId}`
        ).pipe(
            map(res => {
                 return res; 
             }),
            catchError(this.handleError)
        );
    }
    GetAuctionCategories(facilityId): Observable<IAuctionCategories[]> {
        return this.http.get<any>(
            `${this.baseURL}/Store/GetAuctionCategories?facilityId=${facilityId}`)
            .pipe(
                map(res => {
                    return res as any
                }),
                catchError(this.handleError)
            )
    }

    GetStorageTreasureDetails(leaseNo, facilityId):Observable<IAuctionDetails>{
return this.http.get<IAuctionDetails>(
    `${this.baseURL}/Store/GetStorageTreasureDetails?leaseNo=${leaseNo}&facilityId=${facilityId}`)
    .pipe(
        map(res => {
            return res as IAuctionDetails}),
            catchError(this.handleError)
    )
    }

    SaveStorageTreasure(data): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/Store/SaveStorageTreasure`;
        // Filter out empty attachments before sending
        if (data && data.Attachments) {
           data.Attachments = this.filterAttachments(data.Attachments);
        }

        return this.http.post<any>(url, data, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
      // Remove empty/placeholder attachments before sending to the API.
      private filterAttachments(items: any[] | undefined): any[] {
        if (!items || !Array.isArray(items) || items.length === 0) { return []; }
        return items.filter(a => {
          if (!a) { return false; }
          const hasDelete = a.Deleteflag === true || a.DeleteFlag === true || a.deleteFlag === true;
          const hasFileData = (a.AttachmentFile && String(a.AttachmentFile).trim() !== '')
            || (a.AttachmentFileName && String(a.AttachmentFileName).trim() !== '')
            || (a.File && String(a.File).trim() !== '')
            || (a.FileName && String(a.FileName).trim() !== '')
            || (a.AttachmentFilePath && String(a.AttachmentFilePath).trim() !== '');
          const hasId = (a.Id && +a.Id > 0) || (a.IdbId && +a.IdbId > 0);
          return hasDelete || hasFileData || hasId;
        });
      }
    IsStorageTreasureEnabled(facilityId, leaseNo): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Store/IsStorageTreasureEnabled?facilityId=${facilityId}&leaseNo=${leaseNo}`)
            .pipe(
                map(res => {
                    return res as any;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.log('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

    GetUnitStatus(UnitId: number): Observable<number> {
        return this.http.get<number>(
            `${this.baseURL}/Store/GetUnitStatus?unitId=${UnitId}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const statusId = result.body as number;
                        return statusId;
                }
                ),
                catchError(this.handleError)
            );
    }

    SaveUnitStatus(unitLayoutStatusModel: IUnitLayoutStatusModel): Observable<boolean> {
        const options: { headers: HttpHeaders } = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/Store/SaveUnitStatus`;
        return this.http.post<boolean>(url, unitLayoutStatusModel, options)
            .pipe(
                map((res: boolean) => {
                    return res as boolean;
                }),
                catchError(this.handleError)
            );
  }

  SaveBulkAttributes(payload: IBulkAttributeSaveRequest): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Store/SaveBulkAttributes`;
    return this.http.post<ISaveDeleteResponse>(url, payload, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }
}
